import { useLoaderData } from "react-router";

import { Api, Types } from "@/services";
import { ChartsContainer, StatsContainer } from "@/components";

export const statsLoader = async () => {
  const { data } = await Api.ShowStats();
  return data;
};

const Stats = () => {
  const { defaultStats, monthlyApplications } = useLoaderData<Types.Response.ShowStats>();

  return (
    <>
      <StatsContainer defaultStats={defaultStats} />
      {monthlyApplications?.length > 0 && <ChartsContainer data={monthlyApplications} />}
    </>
  );
};

export default Stats;
